import React, { Suspense, lazy } from 'react';
import './App.css';
import './style/index.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Notification from './Components/Notification';
import { useRecoilValue } from 'recoil';
import { toaster } from './Recoil/ActiveEvents';

const Home = lazy(() => import("./Home"));
const Gallery = lazy(() => import("./Gallery"));
const Register = lazy(() => import('./Registration'));
const RegisterVolunteer = lazy(() => import('./Registration/Volunteer'));
const EventsPage = lazy(() => import('./EventsPage'));
const EventHome = lazy(() => import('./NewEvent'));
const NewEvent = lazy(() => import('./NewEvent/NewEvent'));
const LoginPage = lazy(() => import('./auth'));
const UserView = lazy(() => import('./ViewRegistrations'));

function App() {
  const showNotification = useRecoilValue(toaster);

  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<div className="flex min-h-screen items-center justify-center">Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/galllery" element={<Gallery />} />
            <Route path="/registration/:id" element={<Register />} />
            <Route path="/registration" element={<Register />} />
            <Route path="/volunteer-registration" element={<RegisterVolunteer />} />
            <Route path="/admin" element={<EventHome />} />
            <Route path="/createEvent" element={<NewEvent />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/userView" element={<UserView />} />
          </Routes>
        </Suspense>
      </BrowserRouter>

      {!!showNotification && showNotification.showPopup && (
        <Notification
          message="This is a default notification!"
          isShown={showNotification}
        />
      )}
    </div>
  );
}

export default App;
